import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_UNIT_SALES_PRICES } from '../artikelstamm.api';
import { SalesPrice } from '../types/sales-price';
import { SalesPriceQuery } from '../types/sales-price.query';

@Injectable()
export class SalesPriceRepository extends ReadonlyHttpApiListRepository<
  SalesPrice[],
  SalesPriceQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_UNIT_SALES_PRICES);
  }

  override getLoadPathParams(params: SalesPriceQuery): Dictionary<unknown> {
    return { id: params.productId };
  }

  override getLoadQueryParams(params: SalesPriceQuery): Dictionary<unknown> {
    return { showAll: params.showAll };
  }
}
